/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Home_Banner_On_TitleInputs */

const en_simple_home_banner_on_title = /** @type {(inputs: Simple_Home_Banner_On_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple mode is on`)
};

const id_simple_home_banner_on_title = /** @type {(inputs: Simple_Home_Banner_On_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode sederhana aktif`)
};

/**
* | output |
* | --- |
* | "Simple mode is on" |
*
* @param {Simple_Home_Banner_On_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_home_banner_on_title = /** @type {((inputs?: Simple_Home_Banner_On_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Home_Banner_On_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_home_banner_on_title(inputs)
	return en_simple_home_banner_on_title(inputs)
});